import React from 'react'

interface RangeInputProps {
  value: number
  min?: number
  max: number
  step: number
  color: string
  onChange: (v: number) => void
}

export const RangeInput = ({ value, min = 0, max, step, color, onChange }: RangeInputProps) => {
  const pct = max > min ? ((value - min) / (max - min)) * 100 : 0
  return (
    <input
      type='range'
      min={min} max={max} step={step} value={value}
      onChange={e => onChange(Number(e.target.value))}
      style={{
        width: '100%', cursor: 'pointer', outline: 'none',
        WebkitAppearance: 'none', appearance: 'none',
        height: 4, borderRadius: 2,
        background: `linear-gradient(to right, ${color} ${pct}%, #e5e7eb ${pct}%)`,
        '--thumb-color': color,
      } as React.CSSProperties}
    />
  )
}
